import { useEffect, useState } from "react";
import type { SiteSettings } from "@akhshy/types";
import { api } from "../lib/api.ts";
import { errorMessage } from "../lib/errors.ts";
import { LoadingState, ErrorState } from "../components/molecules/StateBlock.tsx";
import { SettingsForm } from "../components/organisms/forms/SettingsForm.tsx";

export function SettingsPage() {
  const [settings, setSettings] = useState<SiteSettings | null>(null);
  const [error, setError] = useState<string | null>(null);

  const load = () => {
    setError(null);
    setSettings(null);
    api.settings
      .get()
      .then(setSettings)
      .catch((err) => setError(errorMessage(err)));
  };

  useEffect(load, []);

  if (error) return <ErrorState message={error} onRetry={load} />;
  if (!settings) return <LoadingState />;
  return (
    <>
      <div className="page-actions">
        <p>The copy on the desk that isn't a content list.</p>
      </div>
      <SettingsForm initial={settings} />
    </>
  );
}
